import { useEffect, useState } from "react";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import getCurrentUserId from "../../../reduxSaga/sagas/requests/currentUserId";
import SellingService from "../../../services/SellingService";
import WarehouseService from "../../../services/WarehouseService";
// import UtilsFormule from "../../../utils/UtilsFormule";
// import update from "immutability-helper";
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";
import { makeStyles } from "@material-ui/core/styles";
// import Stepper from "@material-ui/core/Stepper";
// import Step from "@material-ui/core/Step";
// import StepLabel from "@material-ui/core/StepLabel";
// import { Checkbox } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
// import { FaTable, FaCalendar } from "react-icons/fa";
// import Divider from "@material-ui/core/Divider";
import { Card, Button } from "react-bootstrap";
import "../../../utils/Css/Campagne.css";
import AddDiscountPanier from './AddDiscountPanier';
import AddDiscountProduct from "./AddDiscountProduct";
import {
    getAllBrands,
    getAllFamilies,
    getAllSubFamiliesByFamilyId,
    getAllCategoriesBySubFamilyId,
} from "../../../reduxSaga/actions";
// const styles = {
//     container: (base) => ({
//         ...base,
//         flex: 1,
//     }),
// };
const useStyles = makeStyles((theme) => ({
    root: {
        "& .MuiStepIcon-root.MuiStepIcon-active ": {
            width: "100%",
            color: "#000000",
        },
        "& .MuiStepIcon-root.MuiStepIcon-completed": {
            color: "#000000",
        },
    },
    button: {
        marginRight: theme.spacing(1),
    },
    instructions: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
    },
    icon: {
        color: "#000",
    },
}));
function getSteps() {
    return ["Choisir type promo ", "Créer un devis ", "Finaliser"];
}
const AddDiscount = () => {
    const dispatch = useDispatch();

  
    const [openErrorAlert, setOpenErrorAlert] = useState(false);
    const [errorAlertText, setErrorAlertText] = useState();
    const [allWarehouseSource, setAllWarehouseSource] = useState([{}]);
    const [warehousesSource, setWarehousesSource] = useState([]);

    const [familyId, setFamilyId] = useState(0);
    const [allFamilly, setAllFamilly] = useState([]);
    const [allSubFamilies, setAllSubFamilies] = useState([]);
    const [allCategories, setAllCategories] = useState([]);
    const [typeFamily, setTypeFamily] = useState("");
    const [subFamilyId, setSubFamilyId] = useState(0);
    const [categoryId, setCategoryId] = useState(0);

    const availableFamilies = useSelector(
        (state) => state.staff.availableFamilies
    );
    const availableSubFamilies = useSelector(
        (state) => state.staff.availableSubFamilies
    );



    const [panierClicked, setPanierClicked] = useState(false);
    const [productClicked, setProductClicked] = useState(true);

    useEffect(() => {
        dispatch(getAllFamilies(0));
        dispatch(getAllBrands(0));
    }, []);
    useEffect(() => {
        familyId && dispatch(getAllSubFamiliesByFamilyId(familyId));
    }, [familyId]);
    useEffect(() => {
        subFamilyId && dispatch(getAllCategoriesBySubFamilyId(subFamilyId));
    }, [subFamilyId]);
    useEffect(() => {
        setAllFamilly([]);
        availableFamilies &&
            availableFamilies.map((element, i) => {
                if (i === 0) {
                    setFamilyId(element.id);
                    setTypeFamily(element.type);
                }
                setAllFamilly((oldArray) => [
                    ...oldArray,
                    {
                        value: element.id,
                        label: element.name,
                        customElements: element.type,
                    },
                ]);
            });
    }, [availableFamilies]);

    useEffect(() => {
        if (availableSubFamilies.length === 0) {
            setSubFamilyId(0);
            setCategoryId(0);
        }
        setAllSubFamilies([]);

        availableSubFamilies &&
            availableSubFamilies.map((element, i) => {
                if (i === 0) {
                    setSubFamilyId(element.id);
                }
                setAllSubFamilies((oldArray) => [
                    ...oldArray,
                    {
                        value: element.id,
                        label: element.name,
                        // customElements: element.type,
                    },
                ]);
            });
    }, [availableSubFamilies]);

    useEffect(() => {
        subFamilyId && dispatch(getAllCategoriesBySubFamilyId(subFamilyId));
    }, [subFamilyId]);

    // const [tauxChange, setTauxChange] = useState(0);
    useEffect(() => {
        WarehouseService.getAllRealWarehouse(getCurrentUserId(), 0)
            .then((response) => {
                if (response.data.success) {
                    setWarehousesSource(response.data.success);
                } else {
                    setOpenErrorAlert(true);
                    setErrorAlertText("Erreur : pas de dépôt");
                }
            })
            .catch((e) => {
                console.log("error in getAllRealWarehouse", e);
            });
    }, []);
    useEffect(() => {
        warehousesSource &&
            warehousesSource.map((element) => {
                let exist = false;
                if (allWarehouseSource.length !== 0) {
                    for (let index = 0; index < allWarehouseSource.length; index++) {
                        if (allWarehouseSource[index].value === element?.id) {
                            exist = true;
                            break;
                        }
                    }
                }
                if (element?.id !== undefined && exist === false) {
                    setAllWarehouseSource((oldArray) => [
                        ...oldArray,
                        { value: element.id, label: element.name },
                    ]);
                }
                //here
            });
    }, [warehousesSource]);

    const handleClickPanier = () => {
        setPanierClicked(true);
        setProductClicked(false);
    };

    const handleClickProduct = () => {
        setPanierClicked(false);
        setProductClicked(true);
    };
   
    return (
        <div className="content-wrapper" style={{ marginTop: "0" }}>

            <section className="content-header">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-6"></div>
                        <div className="col-md-6">
                            <ol class="breadcrumb float-sm-right">
                                <li class="breadcrumb-item">Home</li>
                                <li class="breadcrumb-item active">Ajouter promotion</li>
                            </ol>
                        </div>
                    </div>
                </div>
            </section>
            <section className="content ">
                <div className="container-fluid">
                    <div className="row d-flex justify-content-cente">
                        <div className="col">
                            <Button
                                className="my-custom-class-btn-style  mr-2"
                                variant="secondary"
                                disabled={productClicked}
                                onClick={handleClickProduct}
                            >
                                <i class="fab fa-brands fa-product-hunt"></i>{" "} Régle sur Produit
                            </Button>
                        </div>
                        <div className="col">
                            <Button
                                className="my-custom-class-btn-style  mr-2 "
                                variant="secondary"
                                disabled={panierClicked}
                                onClick={handleClickPanier}
                            >
                                <i class="fas fa-shopping-cart"></i>{" "} Régle sur Panier
                            </Button>
                        </div>
                    </div>

                </div>

            </section>
            {productClicked && <AddDiscountProduct />}

            {panierClicked && <AddDiscountPanier />}
        </div>
    );
};
export default AddDiscount;
